import { PlainDatatypes } from '../../../datatype/Datatype';
import { createConditionOperator } from '../IConditionOperator';

export const ConditionOperatorEqualsType = createConditionOperator({
  code: 'equals',
  label: '=',
  description: 'Uguale a',
  args: [{ type: 'referenceValue' }],
  allowsField: field => PlainDatatypes.includes(field.type),
  compare(value: any, [target]: [any]) {
    if (value == null && target == null) return true;
    return value === target;
  },
});
